import React from 'react'

import { AsideSection } from '../AsideSection'
import { CondicoesAutorreferidasCard } from './CondicoesAutorreferidasCard'

export interface CondicoesAutorreferidasSectionProps {
  cidadaoId: ID
}

export function CondicoesAutorreferidasSection(props: CondicoesAutorreferidasSectionProps) {
  const { cidadaoId } = props
  return (
    <AsideSection title='Condições autorreferidas pelo cidadão no cadastro territorial'>
      <CondicoesAutorreferidasCard cidadaoId={cidadaoId} />
    </AsideSection>
  )
}
